export default __webpack_public_path__ + "static/media/settings.ec3d8778.svg";